@let ctx =
  {
    setupPhase: (setupPhase$ | async),
    loadingDialog: (loadingDialog$ | async),
    coupledConnector: (coupledConnector$ | async),
  };
<blaze-panel>
  <div icon class="icon-settings"></div>

  <div title>Setup {{ template?.displayName || template?.target || '' }}</div>

  <ng-container actions>
    <blaze-environment-indicator class="mr-6" />
    @if (isCopyConfigurationButtonVisible) {
      <blaze-copy-connector-config-env-button
        [coupledConnector]="ctx.coupledConnector"
        (copyConfiguration)="copyConfiguration($event)"
      />
    }
    @if (isAuthorizeButtonVisible) {
      <button [disabled]="ctx.loadingDialog" (click)="goToAuth()" blazeBarButton="secondary">
        authorize
      </button>
    }
    @if (isFormButtonVisible) {
      <button [disabled]="ctx.loadingDialog" (click)="goToForm()" blazeBarButton="secondary">
        show form
      </button>
    }
    @if (isSaveButtonVisible) {
      <button
        [disabled]="connectorForm.invalid || ctx.loadingDialog"
        (click)="saveConnector()"
        blazeBarButton="primary"
      >
        {{ saveButtonLabel }}
      </button>
    }
  </ng-container>

  <div content class="dialog-content">
    <div class="flex flex-col items-center">
      @switch (ctx.setupPhase) {
        @case (SetupPhase.Authorization) {
          <ng-template [ngTemplateOutlet]="authorizationTpl" />
        }
        @case (SetupPhase.PopupOpened) {
          <ng-template [ngTemplateOutlet]="popupOpenedTpl" />
        }
        @case (SetupPhase.Install) {
          <ng-template [ngTemplateOutlet]="loadingTpl" />
        }
        @case (SetupPhase.ConnectorCreation) {
          <ng-template [ngTemplateOutlet]="connectorCreationTpl" />
        }
      }
    </div>
  </div>
</blaze-panel>

<ng-template #authorizationTpl>
  <h3 class="mb-16">Login to Microsoft to connect your Microsoft Teams</h3>
  <button
    blazeButton
    blazeIconButtonSize="xl"
    class="bd-btn--primary"
    [disabled]="!authorizationUrl"
    (click)="connect()"
  >
    Sign in with Microsoft
  </button>
</ng-template>

<ng-template #popupOpenedTpl>
  <h3 class="mb-16">Please follow instructions in opened window.</h3>
  <button blazeButton (click)="focusOpenedWindow()"> Focus window </button>
</ng-template>

<ng-template #loadingTpl>
  <div>Loading...</div>
</ng-template>

<ng-template #connectorCreationTpl>
  <form class="flex flex-col w-full" (ngSubmit)="saveConnector()" [formGroup]="connectorForm">
    <label class="field-label bd-field-label required">Name your connector</label>
    <input class="bd-text-input tall" formControlName="connectorName" name="connectorName" />
  </form>
</ng-template>
